import LcChopSimple from "./LcChopSimple";

export { LcChopSimple };
export default LcChopSimple;
